export const UPDATE_AVAILABLE = 'UPDATE_AVAILABLE';
export const UPDATE_PROGRESS = 'UPDATE_PROGRESS';
export const UPDATE_READY = 'UPDATE_READY';
export const UPDATE_RESET = 'UPDATE_RESET';

export const DEEP_LINK_AVAILABLE = 'DEEP_LINK_AVAILABLE';
